import {useEffect, useRef} from "react";
import {useAtom} from "jotai";
import CommonClass from "@/utils/common.ts";
import {all_inits} from "@/atoms/common.ts";
import useAuth from "@/hooks/auth.ts";
import {profile} from "@/atoms/profile.ts";
import DashboardClass from "@/utils/dashboard_class.ts";
import {country_code} from "@/utils/constants.ts";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import {useTranslation} from "react-i18next";
import useCalc from "@/hooks/calculator.ts";
import ProductInterface from "@/types_and_interfaces/product_interface.ts";
import CalculatorLimit from "@/types_and_interfaces/calculator_limit.ts";
import useLoans from "@/hooks/loans.ts";


const AsyncInits = () => {
    const auth = useAuth()
    const [,setInit] = useAtom(all_inits)
    const loaded = useRef<boolean>(false)
    const [user] = useAtom(profile)
    const apply_credit_data = sessionStorage.getItem(CommonClass.local_storage_fields.apply_credit_form_body)
    const i18nextLng = localStorage.getItem(CommonClass.local_storage_fields.i18nextLng)
    const {i18n} = useTranslation()
    const calc = useCalc()
    const product = calc.get_product() as ProductInterface
    const loan_hook = useLoans()
    const lastPreApply = useRef<number>(0)
    const uncommitedCalled = useRef<boolean>(false)

    useEffect(() => {
        if(auth.isRecaptchaReady && apply_credit_data !== null) {
            const data = JSON.parse(apply_credit_data)
            if (typeof data.amn !== "undefined" && typeof data.period !== "undefined") {
                const form = new FormData()
                form.set("amount", String(data.amn))
                form.set("period", String(data.period))
                if (data.phone) form.set("phone", String(data.phone))
                uncommitedCalled.current = true
                loan_hook.uncommited_loan(form)
            }
        }
    }, [auth.isRecaptchaReady]);

    useEffect(() => {
        const init_function = async () => {
            if(Object.keys(CommonClass.general_settings).length) {
                
                try {
                    if(auth.isAuth()) {
                        auth.updateProfile()

                    }
                } catch(e) {
                    console.error("updateProfile", e)
                }
                
                setInit(true);
            }
        }
        
        
        if(!loaded.current) {
            init_function()

            if(typeof i18nextLng === "string" && ["ro", "ru"].includes(i18nextLng) && i18n.language.toLowerCase() !== i18nextLng) {
                i18n.changeLanguage(i18nextLng);
            }
        }
        
        
        return () => {
            
            loaded.current = true
            
        }
        
    }, []);
    
    useEffect(() => {
        if(user && apply_credit_data !== null && product) {

            let data = JSON.parse(apply_credit_data)
            const usr_phone = user.phone

            if(data.hasOwnProperty("phone") && !window.location.href.includes("locations")) {

                const data_phone = country_code + data?.phone.replace(/\s/g, "");

                if(typeof data.amn === "undefined" || typeof data.period === "undefined") return

                const form = new FormData()
                form.set("amount", String(data.amn))
                form.set("period", String(data.period))
                if(data.phone) form.set("phone", String(data.phone))

                const now = Date.now()
                if(now - lastPreApply.current < 10000) return
                lastPreApply.current = now

                if(usr_phone.length) {
                    if(data_phone === usr_phone || (!usr_phone.length && data_phone.length) ) {
                        loan_hook.pre_apply_loan(form, (calc.get_selected_type() as CalculatorLimit).category_name, user, product.product_id)
                        loan_hook.uncommited_loan(form, user)
                        eventEmitter.emit(CommonClass.CustomEvents.redirect_to, DashboardClass.dashboard_routes.ApplyCredit)

                    }

                } else {
                    loan_hook.pre_apply_loan(form, (calc.get_selected_type() as CalculatorLimit).category_name, user, product.product_id)
                    loan_hook.uncommited_loan(form, user)
                    eventEmitter.emit(CommonClass.CustomEvents.redirect_to, DashboardClass.dashboard_routes.ApplyCredit)

                }
            }
        }



    }, [user, product]);
    
    return null
}

export default AsyncInits